<template>
    <div class="dnb-fetch-modal">
        <p class="mt-6 mb-8 text-center">
            {{
                $t('§eq_operator.force_fetch_dnb_report_modal_text', {
                    dnb_created_at: displayAsDate(new Date(modalStore.data.dnb_created_at))
                })
            }}
        </p>

        <div class="flex gap-2">
            <CoreButton
                :loading="clientStore.fetchingDnB"
                label="§ui_button.force_fetch"
                icon="pi-bolt"
                variant="danger"
                @click="handleForceFetch"
            />
            <CoreButton
                :loading="clientStore.fetchingDnB"
                label="§ui_button.fetch_latest_existing"
                icon="pi-download"
                variant="secondary"
                @click="handleFetchLatest"
            />
            <CoreButton
                :disabled="clientStore.fetchingDnB"
                label="§ui_button.cancel"
                icon="pi-times"
                variant="tertiary"
                @click="modalStore.setClose"
            />
        </div>
    </div>
</template>

<script>
import { useClientStore } from '@/stores/client'
import { useModalStore } from '@/stores/modal'
import CoreButton from '@/components/core/CoreButton.vue'

export default {
    name: 'DnbReportFetchModal',
    components: { CoreButton },
    data() {
        return {
            clientStore: useClientStore(),
            modalStore: useModalStore(),
        }
    },
    methods: {
        async handleForceFetch() {
            await this.clientStore.fetchDnB(true)
            this.modalStore.setClose()
        },
        async handleFetchLatest() {
            await this.clientStore.fetchDnB(false)
            this.modalStore.setClose()
        },
    },
}
</script>
